import styled from 'styled-components';

export const Logo = styled.img`
  display: block;
  margin: auto;
  margin-bottom: 45px;
`;

export const MainSection = styled.main`
  margin: auto;
  padding: 0 30px;
  width: 80%;
`;

export const Container = styled.section`
  padding: 45px 10px;
  text-align: center;
`;

export const TextSection = styled.section`
  margin: auto;
  max-width: 1100px;
  padding: 10px 30px;
  font-size: 18px;
  margin-bottom: 150px;
`;

export const Footer = styled.footer`
  margin-top: 50px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

export const FooterLogo = styled.img`
  width: 120px;
  height: auto;
`;

export const FooterText = styled.p`
  color: #666;
  font-size: 14px;
  margin: 0;
`;
